import { message } from 'antd'
import { deleteClientContact } from '../../../HttpRequests/clientContacts'
import { getProps } from '../props'
import handleException from '../../../Core/Helpers/handleException'

export default () => async () => {

  const { clientContact, onClose, didDelete } = getProps()

  try {

    await deleteClientContact({ id: clientContact.id })

    message.success('Contact Deleted')

    onClose(true)

    if (didDelete) didDelete()

  } catch (error) {

    handleException(error)

  }

}
